import React from 'react';

import { EnumData } from '../../../../utils/enumData';
import { PlexRadioGroup } from '../../../shared/primitives/PlexRadioGroup';
import { Heading } from '../Heading';
import { SettingsContent } from '../SettingsContent';
import { SettingsPageProps } from './types';

export const Security = ({
  savedSettings,
  unsavedSettings,
  loadingMutation,
  onChange,
  onSave,
  onCancel,
  updateDisabled,
}: SettingsPageProps): React.ReactElement | null => {
  const { domain } = savedSettings;
  if (!domain) {
    return null;
  }
  const authorizedDomainOptions: EnumData<boolean> = {
    ANYONE_FROM_DOMAIN: {
      displayName: `Allow anyone to sign up with an email from allhandshq.com`,
      value: true,
    },
    INVITE_ONLY: {
      displayName: 'Only admins can invite new users',
      value: false,
    },
  };

  return (
    <SettingsContent
      title={'Security'}
      onSave={onSave}
      onCancel={onCancel}
      updateDisabled={updateDisabled}
      loadingMutation={loadingMutation}
    >
      <Heading text={'Authorized Domains'} />
      <PlexRadioGroup
        handleChange={(value): void => onChange({ domain: { authorizedDomain: value } })}
        name={'authorizedDomain'}
        value={
          unsavedSettings?.domain?.authorizedDomain != null
            ? unsavedSettings.domain.authorizedDomain
            : domain.authorizedDomain
        }
        options={authorizedDomainOptions}
      />
    </SettingsContent>
  );
};
